<template>
  <div class="loading-container" v-if="isLoading">
    <div class="fingerprint-spinner">
      <img src="/fingerprint.svg" alt="Loading" class="fingerprint-image" />
      <div class="pulse-ring"></div>
    </div>
    <p class="loading-text">{{ loadingText }}</p>
    
    <!-- 進度條 -->
    <div class="progress-container" v-if="showProgress">
      <div class="progress-bar">
        <div class="progress-fill" :style="{ width: progress + '%' }"></div>
      </div>
      <div class="progress-text">{{ Math.round(progress) }}%</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
  props: {
    isLoading: {
      type: Boolean,
      default: true
    },
    loadingText: {
      type: String,
      default: 'Loading...'
    },
    showProgress: {
      type: Boolean,
      default: false
    },
    minLoadTime: {
      type: Number,
      default: 2000 // 最少顯示2秒
    }
  },
  data() {
    return {
      progress: 0,
      startTime: 0,
      progressInterval: null
    }
  },
  watch: {
    isLoading(newVal) {
      if (newVal) {
        this.startLoading();
      } else {
        this.completeLoading();
      }
    }
  },
  mounted() {
    if (this.isLoading) {
      this.startLoading();
    }
  },
  beforeDestroy() {
    if (this.progressInterval) {
      clearInterval(this.progressInterval);
    }
  },
  methods: {
    startLoading() {
      this.progress = 0;
      this.startTime = Date.now();
      
      if (this.showProgress) {
        this.simulateProgress();
      }
    },
    
    simulateProgress() {
      if (this.progressInterval) {
        clearInterval(this.progressInterval);
      }
      
      this.progressInterval = setInterval(() => {
        if (this.progress < 90) {
          // 逐漸減慢進度速度
          const increment = Math.max(1, 15 - (this.progress / 10));
          this.progress += Math.random() * increment;
          this.progress = Math.min(this.progress, 90);
        }
      }, 100 + Math.random() * 200);
    },
    
    completeLoading() {
      const elapsedTime = Date.now() - this.startTime;
      const remainingTime = Math.max(0, this.minLoadTime - elapsedTime);
      
      if (this.showProgress) {
        // 快速完成進度條
        this.progress = 100;
      }
      
      // 確保最少顯示時間
      setTimeout(() => {
        this.$emit('loading-complete');
        if (this.progressInterval) {
          clearInterval(this.progressInterval);
        }
      }, remainingTime);
    }
  }
}
</script>

<style scoped>
.loading-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.95);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  backdrop-filter: blur(5px);
  animation: fadeIn 0.5s ease-in;
}

.fingerprint-spinner {
  width: 120px;
  height: 120px;
  position: relative;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fingerprint-image {
  width: 80px;
  height: 80px;
  z-index: 2;
  animation: rotate 3s linear infinite;
  filter: drop-shadow(0 0 15px rgba(240, 131, 30, 0.4));
}

.pulse-ring {
  position: absolute;
  width: 120px;
  height: 120px;
  border: 3px solid rgba(240, 131, 30, 0.3);
  border-radius: 50%;
  animation: pulse 2s ease-in-out infinite;
}

.loading-text {
  font-size: 20px;
  color: #004D6B;
  margin-bottom: 20px;
  font-weight: 500;
  text-align: center;
}

.progress-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 250px;
}

.progress-bar {
  width: 100%;
  height: 8px;
  background-color: rgba(240, 131, 30, 0.2);
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 10px;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, rgba(240, 131, 30, 0.8), rgba(240, 131, 30, 1));
  border-radius: 4px;
  transition: width 0.3s ease;
  box-shadow: 0 0 10px rgba(240, 131, 30, 0.3);
}

.progress-text {
  font-size: 14px;
  color: #004D6B;
  font-weight: 500;
}

@keyframes rotate {
  0% { 
    transform: rotate(0deg);
  } 
  100% { 
    transform: rotate(360deg);
  }
}

@keyframes pulse {
  0% {
    transform: scale(0.8);
    opacity: 1;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.4;
  }
  100% {
    transform: scale(0.8);
    opacity: 1;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style> 